import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';
import { Grid } from '@material-ui/core';
import {
  dateType,
  dateTimeType,
  userType,
} from '@pingum/api-services/EventDataService/EventDataTypes';
import Property from '../Property';
import {
  formatDate,
  formatDateOnly,
} from '../../../utils/dateHelper';
import User from '../User';

export const getEventDataDisplayValue = (data, tenantUsers) => {
  if (
    data.type === dateType
      && data.value
      && data.value.length > 0
  ) {
    return formatDateOnly(data.value);
  }

  if (
    data.type === dateTimeType
      && data.value
      && data.value.length > 0
  ) {
    return formatDate(data.value);
  }

  if (
    data.type === userType
      && data.value
      && data.value.length > 0
  ) {
    // First determine if the event has new formatting
    if (data.value.indexOf('@[') >= 0) {
      const users = data.value.split(/(?=@\[)/);
      return users.sort((a, b) => a - b).map((item) => {
        const userList = tenantUsers
          ? tenantUsers.filter((tenantUser) => item.indexOf(tenantUser.auth0UserId) >= 0)
          : [];
        const user = userList.length > 0
          ? userList[0]
          : {
            auth0UserId: '-1',
            email: item,
            firstName: '',
            lastName: '',
          };
        return (
          <User
            key={user.auth0UserId}
            user={user}
            chip
          />
        );
      });
    }

    // TODO remove this eventually... ?
    const users = data.value.split(',');
    return users.sort((a, b) => a - b).map((item) => {
      const userList = tenantUsers
        ? tenantUsers.filter((tenantUser) => tenantUser.email === item.trim())
        : [];
      const user = userList.length > 0
        ? userList[0]
        : {
          auth0UserId: '-1',
          email: item,
          firstName: '',
          lastName: '',
        };
      return (
        <User
          key={user.auth0UserId}
          user={user}
          chip
        />
      );
    });
  }

  return data.value;
};

class EventDataList extends React.Component {
  render() {
    const {
      eventData,
      tenantUsers,
      responsive,
      allEventData,
    } = this.props;

    // loop over event data in order so we can display in order
    const labelsInOrder = [];
    const sortedEventData = sortBy(allEventData, ['order', 'name']);
    for (let i = 0; i < sortedEventData.length; i += 1) {
      if (eventData[sortedEventData[i].name]) {
        // event data exists in object so add to label list
        labelsInOrder.push(sortedEventData[i].name);
      }
    }

    const sizes = {
      xs: 12,
      sm: 6,
      md: 4,
      lg: 3,
      xl: 2,
    };

    return (
      <Grid container>
        {
          labelsInOrder.length === 0
            && (
              <Property label="" />
            )
        }
        {
          labelsInOrder.map((label) => (
            <Grid
              item
              key={`event-data-${label}`}
              {
                ...(
                  !responsive
                    ? { xs: sizes.xs }
                    : sizes
                )
              }
            >
              <Property
                key={`event-data-${label.replace(' ', '-')}`}
                label={label}
              >
                {
                  getEventDataDisplayValue(((eventData || {})[label] || {
                    value: '-',
                    type: 'text',
                  }), tenantUsers)
                }
              </Property>
            </Grid>
          ))
        }
      </Grid>
    );
  }
}

EventDataList.propTypes = {
  eventData: PropTypes.object,
  tenantUsers: PropTypes.array,
  responsive: PropTypes.bool,
  allEventData: PropTypes.array,
};

EventDataList.defaultProps = {
  eventData: {},
  tenantUsers: [],
  responsive: false,
  allEventData: [],
};

export const mapStateToProps = (state) => ({ tenantUsers: state.tenant.tenantUsers });

export default connect(mapStateToProps)(EventDataList);
